import type * as gridstack from 'gridstack'

import type * as state from '../../../../../../../../../state'

export interface State {
  segmentLookup: state.mosaic.dev.pages.models.Segment.Lookup
  currentSegmentId?: state.mosaic.dev.pages.models.Segment.Id
  widgetFrameLookup: state.mosaic.dev.pages.models.widget.Frame.Lookup
  grid?: gridstack.GridStack
  editingWidgetFrameId?: state.mosaic.dev.pages.models.widget.Frame.Id
  /**
   * Containing the segment currently being modified in the edit dialog
   */
  editingSegment: Partial<state.mosaic.dev.pages.models.Segment>
  editingSegmentId?: state.mosaic.dev.pages.models.Segment.Id
  /**
   * Whether the overflow actions overlay is currently open
   */
  presentOverflowActions: boolean
  /**
   * Configuration used for segment confirmation dialog in case when creating
   * new segment or switching to another segment, but previous selected segment
   * does not have optimized layout
   */
  switchingSegmentConfiguration?: {
    /**
     * Represents segment that should be selected when using segment confirmation
     * dialog
     */
    segment?: state.mosaic.dev.pages.models.Segment
    /**
     * Tracks if it is a new segment creation
     */
    isNew: boolean
  }

  /**
   * Indicates whether the currently edited page state
   * is marked for discard—typically used to control cleanup behavior
   * when the user cancels or navigates away from an unsaved edit.
   */
  markedForDiscard: boolean
}

export namespace State {
  export const INITIAL: Readonly<State> = {
    editingSegment: {},
    markedForDiscard: false,
    presentOverflowActions: false,
    segmentLookup: {},
    widgetFrameLookup: {},
  }
}
